export default {
    header: "Has sido desconectado con éxito",
    message: ""
}